import { useEffect, useState } from "react";
import { NAVBAR_SCROLL_THRESHOLD_PX } from "@/constants/app";

export default function useScrollBehavior(threshold = NAVBAR_SCROLL_THRESHOLD_PX) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    // `setScrolled` is stable (returned from useState) and `onScroll` is
    // defined inside the effect, so they are intentionally not in the deps.
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return scrolled;
}
